import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ENDPOINTS } from "../../../js/api/_config";

export const getRecruiterLists = createAsyncThunk('/getRecruiterList', async (data, { rejectWithValue }) => {
    const value = data.clinicId ? data.clinicId : null
    const query = `?clinicalInfoID=${value}`
    try {
        const response = await axios.get(`${ENDPOINTS.RECRUITERS.GET_RECTRUITERS}${value ? query : ''}`)
        return response.data;
    } catch (error) {
        return rejectWithValue(
            error.response?.data ||
            "Something went wrong while fetching the buyer profile."
        );
    }
})

const initialState = {
    data: [],
    isLoading: true,
    error: null,
};

const getRecruiterListSlice = createSlice(
    {
        name: "recruiter",
        initialState,
        extraReducers: (builder) => {
            builder.addCase(getRecruiterLists.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.isLoading = false;
                state.error = null;
            })
                .addCase(getRecruiterLists.pending, (state) => {
                    state.isLoading = true;
                    state.error = null;
                })
                .addCase(getRecruiterLists.rejected, (state, action) => {
                    state.isLoading = false;
                    state.error = action.payload;
                })
        }
    }
)

export default getRecruiterListSlice.reducer;